import { render, staticRenderFns } from "./SpecialtyUpdate.vue?vue&type=template&id=1ddd78d4&"
import script from "./SpecialtyUpdate.vue?vue&type=script&lang=js&"
export * from "./SpecialtyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports